import Axios, { AxiosPromise, AxiosResponse } from 'axios';
import { getGoogleCaptchaKey, getNewDapiPath } from 'ts/config/ConfigService';
import { AccountResponse } from './AccountResponse';
import { getTokenCaptchaV3 } from '../captcha/CaptchaService';

const findAccountForManualReg = (
  lastName: string,
  dateOfBirth: string,
  postcode: string,
  captchaToken: string,
  accountNumber?: string,
  userProvidedEmail?: string,
): AxiosPromise<AccountResponse> => {
  return Axios.get<AccountResponse>(`${getNewDapiPath()}/v1/manualreg/users`, {
    headers: {
      'cache-control': 'no-cache',
    },
    params: {
      lastName,
      dateOfBirth,
      postcode,
      captchaToken,
      accountNumber,
      userProvidedEmail,
    },
  });
};

const findAccountForManualRegWithCaptcha = async (
  lastName: string,
  dateOfBirth: string,
  postcode: string,
  accountNumber?: string,
  userProvidedEmail?: string,
): Promise<AxiosResponse<AccountResponse>> => {
  const captchaToken = await getTokenCaptchaV3(getGoogleCaptchaKey());
  return findAccountForManualReg(
    lastName,
    dateOfBirth,
    postcode,
    captchaToken,
    accountNumber,
    userProvidedEmail,
  );
};

const findBusinessAccountForManualReg = (
  accountNumber: string,
  businessName: string,
  abn: string,
  captchaToken: string,
): AxiosPromise<AccountResponse> =>
  Axios.get<AccountResponse>(`${getNewDapiPath()}/v1/manualreg/business-users`, {
    headers: {
      'cache-control': 'no-cache',
    },
    params: {
      accountNumber,
      businessName,
      abn,
      captchaToken,
    },
  });

const findBusinessAccountForManualRegWithCaptcha = async (
  accountNumber: string,
  businessName: string,
  abn: string,
): Promise<AxiosResponse<AccountResponse>> => {
  const captchaToken = await getTokenCaptchaV3(getGoogleCaptchaKey());
  return findBusinessAccountForManualReg(accountNumber, businessName, abn, captchaToken);
};

const findAccountByCriteria = (
  lastName: string,
  dateOfBirth: string,
  postcode: string,
  accountNumber?: string,
): AxiosPromise<AccountResponse> => {
  return Axios.get<AccountResponse>(`${getNewDapiPath()}/v2/users`, {
    headers: {
      'cache-control': 'no-cache',
    },
    params: {
      lastName,
      dateOfBirth,
      postcode,
      accountNumber,
    },
  });
};

const findSmeAccountByCriteria = (
  businessName: string,
  abn: string,
  accountNumber: string,
): AxiosPromise<AccountResponse> => {
  return Axios.get<AccountResponse>(`${getNewDapiPath()}/v2/users/sme`, {
    headers: {
      'cache-control': 'no-cache',
    },
    params: {
      businessName,
      abn,
      accountNumber,
    },
  });
};

export {
  findAccountByCriteria,
  findSmeAccountByCriteria,
  findAccountForManualRegWithCaptcha,
  findBusinessAccountForManualRegWithCaptcha,
};
